<template>
  <div>
    <h2>{{ quote.goodsDescriptions }}</h2>
    <b-row class="mb-2">
      <b-col>
        <span>ดูแล้ว: {{ quote.viewCount ? quote.viewCount : '0' }} ครั้ง</span>
        <br />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" xl="8">
        <MainDetail :quote="quote" :profile="profile" />
      </b-col>
      <b-col v-if="quote.status < 20" md="12" xl="4">
        <b-card class="d-lg-down-none job-docs-position-fixed">
          <h5>ใบเสนอราคา</h5>
          <h6 class="text-logisty-profile-heading mt-4">เอกสารจากผู้ว่าจ้าง</h6>
          <FileList ref="shipperQuoteFileList" :refId="quote._id" docType="carrier-quote" :preventDelete="true" docClass="request"/>
          <hr class="divider" />
          <h6 v-if="!isMyJob" class="text-logisty-profile-heading mt-4">เอกสารของเรา</h6>
          <FileList v-if="!isMyJob" ref="carrierQuoteFileList" :refId="quote._id" docType="carrier-quote" :preventDelete="false" docClass="response"/>
          <h6 v-if="!isMyJob" class="text-logisty-profile-heading mt-2">ส่งเอกสารเพิ่ม</h6>
          <UploadFile
            v-if="!isMyJob"
            ref="carrierQuoteFileUpload"
            docType="carrier-quote"
            :refId="quote._id"
            :showHeader="false"
            :noDrag="true"
          />
        </b-card>
        <b-card class="d-xl-none">
          <h5>ใบเสนอราคา</h5>
          <h6 class="text-logisty-profile-heading mt-4">เอกสารจากผู้ว่าจ้าง</h6>
          <FileList ref="shipperQuoteFileList" :refId="quote._id" docType="carrier-quote" :preventDelete="true" docClass="request"/>
          <hr class="divider" />
          <h6 v-if="!isMyJob" class="text-logisty-profile-heading mt-4">เอกสารของเรา</h6>
          <FileList v-if="!isMyJob" ref="carrierQuoteFileList" :refId="quote._id" docType="carrier-quote" :preventDelete="false" docClass="response"/>
          <h6 v-if="!isMyJob" class="text-logisty-profile-heading mt-2">ส่งเอกสารเพิ่ม</h6>
          <UploadFile
            v-if="!isMyJob"
            ref="carrierQuoteFileUpload"
            docType="carrier-quote"
            :refId="quote._id"
            :showHeader="false"
            :noDrag="true"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import MainDetail from './MainDetail'
import Quote from '../../services/http/Quote'
import Profile from '../../services/http/Profile'

import UploadFile from '../../components/UploadFile'
import FileList from '../../components/FileList'

export default {
  components: {
    MainDetail,
    UploadFile,
    FileList
  },
  data () {
    return {
      quote: null,
      profile: null,
      isMyJob: false
    }
  },
  async mounted () {
    window.analytics.track('quote-detail-open', {
      jobId: this.$route.params.jobId
    })
    // load myquote
    try {
      var quote = new Quote()
      var data = {
        quoteRequestJobId: this.$route.params.jobId
      }
      var result = await quote.carrierGetOneQuote(data)
      if (result.code === 1) {
        this.quote = result.data
        let companyId = this.$cookies.get('companyId')
        if (companyId === this.quote.shipper._id) {
          this.isMyJob = true
          // redirect to myjob
          this.$router.push({ name: 'รายละเอียดใบขอราคาของฉัน', params: { jobId: this.quote._id } })
        }

        await quote.carrierIncreaseViewcount(data)

        var profile = new Profile()
        var companyProfile = await profile.getPrivateProfileById(this.quote.shipper._id)

        if (companyProfile.code === 1) {
          this.profile = companyProfile.data
        } else {
          alert('ไม่พบข้อมูลบริษัท')
          this.$router.push({ name: 'ใบขอราคาทั้งหมด', params: { tabName: 'all' } })
        }
      } else {
        alert('ไม่สามารถโหลดข้อมูลงานได้')
        this.$router.push({ name: 'ใบขอราคาทั้งหมด', params: { tabName: 'all' } })
      }
    } catch (error) {
      alert('โปรดติดต่อผู้ดูแลระบบ')
      console.log(error)
    }
  }
}
</script>
